import React from 'react';
import styled from 'styled-components';
import { genAuthURL } from 'utils';
import { useDispatch, useSelector } from 'react-redux'

import { Modal, Button } from 'components';
import { GoogleButton } from 'features';

import * as actionCreators from 'store/actions';

const Container = styled.div`
    background-color: var(--primary-color);
    border: 1px solid var(--secondary-color);
    border-radius: 5px;
    padding: 1rem;
    display: grid;
    grid-template-rows: auto auto auto;
    justify-content: center;
    align-items: center;
    justify-content: center;
    width: 25rem;
`

const Title = styled.div`
    font-weight: bold;
    text-align: center;
    margin-bottom: 0.5rem;
`

const Text = styled.div`
    font-size: 0.9rem;
    text-align: center;
    margin-bottom: 0.5rem;
`

const Cancel = styled.div`
    margin-top: 0.5rem;
    font-size: 0.8rem;
    cursor: pointer;
    text-align: center;
    :hover {
        text-decoration: underline;
    }
`

const GoogleModal = props => {
    const {
        client,
        title,
        text
    } = props;
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user)

    const onClose = () => {
        dispatch(actionCreators.setModal(null,null))
    }

    const onSelect = () => {
        client && genAuthURL(client.toUpperCase(), user['uid'])
        dispatch(actionCreators.setModal(null,null))
    }

    return(
        <Modal>
            <Container>
                <Title>{title || 'Google Login'}</Title>
                <Text>{text || "We'll need you to login to your Google account to authorize Atomicly.io to read your data"}</Text>
                <GoogleButton text='Sign in with Google' onSelect={onSelect}/>
                <Cancel onClick={onClose}>Back</Cancel>
            </Container>
        </Modal>
        
    )
}

export default GoogleModal;